import { BankDetailsSchema, InvitationDesignFormData } from "./definitions";

import { fetchAPI } from "./fetch-api";

/** Init settings (bar_text, etc.) must stay fresh — stale Next Data Cache was
 *  serving old values like "test test" after API/DB updates. */
export const INIT_REVALIDATE_SECONDS = 0;

const initFetchOptions = (token?: string) =>
  !token
    ? {
        publicGet: true as const,
        noStore: true as const,
      }
    : { noStore: true as const };

export async function fetchHomePage() {
  return fetchAPI(`/user/home`, {
    method: "GET",
    publicGet: true,
  });
}
export async function fetchStoreHomePage() {
  return fetchAPI(`/store/home`, {
    method: "GET",
    publicGet: true,
  });
}
// /store/sub-categories/4?limit=20&page=1
export async function fetchStoreSubCategories(type_id: any, params: string) {
  return fetchAPI(`/store/sub-categories/${type_id}?${params}`, {
    method: "GET",
    publicGet: true,
  });
}
// /store/products/7?limit=20&page=1
export async function fetchStoreProducts(id?: any, params?: string) {
  return fetchAPI(`/store/products/${id}?${params}`, {
    method: "GET",
    publicGet: true,
  });
}
export async function fetchSearchStoreProducts(params?: string) {
  return fetchAPI(`/store/products?${params}`, {
    method: "GET",
    publicGet: true,
  });
}
// /store/orders/checkout
export async function fetchStoreCheckout(data: any, token?: string) {
  return fetchAPI(`/store/orders/checkout`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}
// /store/product-details/1
export async function fetchStoreProductDetails(id: any, token?: string) {
  return fetchAPI(`/store/product-details/${id}`, {
    method: "GET",
    authToken: token,
  });
}

// {{url}}/store/category-details/{category id}
export async function fetchStoreCategoryDetails(id: any) {
  return fetchAPI(`/store/category-details/${id}`, {
    method: "GET",
    publicGet: true,
  });
}
export async function fetchSellerHomePage(token?: string, keyword?: string) {
  return fetchAPI(`/seller/events?event=${encodeURIComponent(keyword || "")}`, {
    method: "GET",
    authToken: token,
  });
}

export async function fetchTransfers(
  page?: string,
  limit = 10,
  token?: string,
) {
  return fetchAPI(`/invoices?limit=${limit}&page=${page}&transfers=1`, {
    method: "GET",
    authToken: token,
  });
}
export async function fetchSellerSearch(token?: string, keyword?: string) {
  return fetchAPI(
    `/seller/events/search?q=${encodeURIComponent(keyword || "")}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}
export async function fetchEvents(id: any, keyword = "") {
  const isSeller = id == "seller";

  return fetchAPI(
    isSeller
      ? `/seller/events/search?q=${encodeURIComponent(keyword)}`
      : `/user/events/category/` + id + `?event=${encodeURIComponent(keyword)}`,
    {
      method: "GET",
      ...(isSeller
        ? {}
        : {
            publicGet: true,
            next: {
              revalidate: 60,
              tags: [`category:${id}`, `category-events:${id}`],
            },
          }),
    },
  );
}

export async function fetchExpiredEvents(id: any, keyword = "") {
  return fetchAPI(
    `/user/events/category/${id}/expired?event=${encodeURIComponent(keyword)}`,
    {
      method: "GET",
      publicGet: true,
      next: {
        revalidate: 300,
        tags: [`category:${id}`, `category-expired:${id}`],
      },
    },
  );
}
export async function searchEvents(key: string) {
  return fetchAPI(`/user/events/search?event=${encodeURIComponent(key)}`, {
    method: "GET",
    publicGet: true,
  });
}
export async function fetchEventDetails(
  id: any,
  options?: { next?: { revalidate?: number; tags?: string[] } },
) {
  return fetchAPI(`/user/events/` + id, {
    method: "GET",
    ...(options?.next && { next: options.next }),
  });
}
export async function fetchSellerEventDetails(id: any) {
  return fetchAPI(`/seller/events/` + id, {
    method: "GET",
  });
}
export async function fetchCategoryDetails(id: any) {
  return fetchAPI(`/user/category/` + id, {
    method: "GET",
    publicGet: true,
    next: {
      revalidate: 60,
      tags: [`category:${id}`],
    },
  });
}
export async function fetchReferralEventDetails(id: any) {
  return fetchAPI(`/referral-event/` + id, {
    method: "GET",
  });
}

export async function fetchGlobalData() {
  return fetchAPI(`/init?platform=android&version=1.1.0`, {
    method: "GET",
    publicGet: true,
    noStore: true,
  });
}

export async function fetchPayementMethods(data?: any) {
  return fetchAPI(`/orders/check-payment-method`, {
    method: "POST",
    body: data,
  });
}

export async function NewfetchPayementMethods() {
  return fetchAPI(`/init`, {
    method: "GET",
    publicGet: true,
    noStore: true,
  });
}

export async function fetchCreateOrder(data: any, token?: string) {
  return fetchAPI(`/orders/store`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}

export async function fetchStoreCreateOrder(data: any, token?: string) {
  return fetchAPI(`/store/orders/add-order`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}

export async function fetchStoreOrderPaid(
  data: {
    order_id: number;
    ref_id: string;
    payment_method: string;
    other_payment_method?: string | null;
  },
  token?: string,
) {
  return fetchAPI(`/store/orders/paid`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}

export async function CalculateCachBackValue(data: any, token?: string) {
  return fetchAPI(`/orders/calc-cashback-value`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}
export async function fetchAddToWallet(data: any, token?: string) {
  return fetchAPI(`/wallet/store`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}

export async function PaidFun(data: any, token?: string) {
  return fetchAPI(`/orders/paid`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}

export async function getPayMentURL(data: any) {
  return fetchAPI(`/orders/get-payment-url`, {
    method: "POST",
    body: data,
  });
}
export async function getPayMentURLWallet(data: any) {
  return fetchAPI(`/wallet/get-payment-url`, {
    method: "POST",
    body: data,
  });
}
export async function getPayMentURLInvoices(data: any) {
  return fetchAPI(`/invoices/get-payment-url`, {
    method: "POST",
    body: data,
  });
}
export async function fetchApplyCoupon(data: any, token?: string) {
  return fetchAPI(`/orders/apply-coupon`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}
export async function fetchStoreApplyCoupon(data: any, token?: string) {
  return fetchAPI(`/store/orders/apply-coupon`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}
export async function fetchStorePaymentURL(data: any) {
  return fetchAPI(`/store/orders/get-payment-url`, {
    method: "POST",
    body: data,
  });
}
export async function fetchPaidOrder(data: any) {
  return fetchAPI(`/orders/paid`, {
    method: "POST",
    body: data,
  });
}

export async function fetchFaqs() {
  return fetchAPI(`/pages/faq`, {
    method: "GET",
    publicGet: true,
    next: { revalidate: 900 },
  });
}
export async function fetchTerms() {
  return fetchAPI(`/pages/terms`, {
    method: "GET",
    publicGet: true,
    next: { revalidate: 900 },
  });
}
export async function fetchPrivacy() {
  return fetchAPI(`/pages/security`, {
    method: "GET",
    publicGet: true,
    next: { revalidate: 900 },
  });
}
export async function fetchAbout() {
  return fetchAPI(`/pages/about-us`, {
    method: "GET",
    publicGet: true,
    next: { revalidate: 900 },
  });
}
export async function fetchMyTickets(
  page: string,
  limit = 2,
  type: string,
  token?: string,
) {
  return fetchAPI(`/user/tickets?limit=${limit}&page=${page}&type=${type}`, {
    method: "GET",
    authToken: token,
    noStore: true,
  });
}
export async function fetchSellerOrders(
  page: string,
  limit = 2,
  type: string,
  keyword: string,
  token?: string,
) {
  return fetchAPI(
    `/seller/orders?limit=${limit}&page=${page}&type=${type}&event=${keyword}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}
export async function fetchSellerTickets(
  page: string,
  limit = 2,
  type: string,
  keyword: string,
  token?: string,
) {
  return fetchAPI(
    `/seller/tickets?limit=${limit}&page=${page}&type=${type}&event=${keyword}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}
export async function fetchSellerInvoices(
  page?: string,
  limit = 10,
  token?: string,
) {
  return fetchAPI(`/invoices?limit=${limit}&page=${page}`, {
    method: "GET",
    authToken: token,
  });
}

export async function fetchExpressTickets(
  page?: string,
  limit = 10,
  token?: string,
) {
  return;
}

export async function fetchInvoiceProfile(token?: string) {
  return fetchAPI(`/invoices/profile`, {
    method: "GET",
    authToken: token,
  });
}
export async function fetchInit(token?: string, platform = "android") {
  return fetchAPI(`/init?platform=${platform}&version=1.1.0`, {
    method: "GET",
    authToken: token,
    ...initFetchOptions(token),
  });
}
export async function fetchMyTicketsDetails(id: string, token?: string) {
  return fetchAPI(`/user/tickets/` + id, {
    method: "GET",
    authToken: token,
    noStore: true,
  });
}

export async function handleReciveFun(
  id: string,
  token?: string,
  endPiont?: string,
) {
  return fetchAPI(`/user/tickets/${endPiont}/` + id, {
    method: "POST",
    authToken: token,
    noStore: true,
  });
}

export async function handle_update_company_details(
  id: string,
  token?: string,
  body?: any,
) {
  return fetchAPI(`/user/tickets/update-company-details/` + id, {
    method: "POST",
    authToken: token,
    body: body,
  });
}

export async function fetchSellerTicketDetails(id: string, token?: string) {
  return fetchAPI(`/seller/tickets/` + id, {
    method: "GET",
    authToken: token,
  });
}
export async function fetchOrderDetails(id: string, token?: string) {
  return fetchAPI(`/seller/orders/` + id, {
    method: "GET",
    authToken: token,
  });
}

export async function AddBankDetails(data: any, token?: string) {
  return fetchAPI(`/seller/update-bank`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}
export async function CreateTicket(data: any, token?: string) {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_URL}/tickets/store`,
    {
      method: "POST",
      headers: {
        "X-SECRET-KEY": process.env.NEXT_PUBLIC_API_SECRET_KEY || "",
        Authorization: `Bearer ${token}`,
      },
      body: data,
    },
  );
  return response?.json();
}
export async function UpdateProfile(data: any, token?: string) {
  return fetchAPI(`/profile/update`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}
export async function UpdatePhone(data: any, token?: string) {
  return fetchAPI(`/profile/update-phone`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}
export async function ResendOtp(data: any, token?: string) {
  return fetchAPI(`/auth/resend`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}
export async function upload(formData: any) {
  const response = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/upload`, {
    method: "POST",
    headers: {
      "X-SECRET-KEY": process.env.NEXT_PUBLIC_API_SECRET_KEY || "",
    },
    body: formData,
  });
  return response?.json();
}
export async function fetchProfile(token?: string) {
  return fetchAPI(`/profile`, {
    method: "GET",
    authToken: token,
    next: { revalidate: 0 },
  });
}
export async function fetchWallet(
  page: string,
  limit: number,
  keyword: string,
  token?: string,
) {
  return fetchAPI(
    `/seller/wallet?limit=${limit}&page=${page}&event=${keyword}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}
export async function fetchMarketingWallet(
  page: string,
  limit: number,
  keyword: string,
  token?: string,
) {
  return fetchAPI(
    `/marketing/transactions?limit=${limit}&page=${page}&event=${keyword}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function bankdata(formData: any) {
  const res = await fetchAPI(`/seller/update-bank`, {
    method: "POST",
    body: formData,
  });

  return res;
}

export async function marketingBankdata(formData: any) {
  const res = await fetchAPI(`/marketing/transactions/store`, {
    method: "POST",
    body: formData,
  });

  return res;
}
export async function approveOrder(id: any, token?: string) {
  return fetchAPI(`/seller/orders/${id}/approve`, {
    method: "POST",
    authToken: token,
  });
}
export async function toggleStatus(id: any, token?: string) {
  return fetchAPI(`/seller/tickets/${id}/update-status`, {
    method: "POST",
    authToken: token,
  });
}
export async function toggleAllStatus(id: any, body: any, token?: string) {
  return fetchAPI(`/seller/tickets/update-status?ticket_id=${id}`, {
    method: "POST",
    authToken: token,
    body,
  });
}
export async function updateTicketDetails(id: any, body: any, token?: string) {
  return fetchAPI(`/seller/tickets/${id}/update-details`, {
    method: "POST",
    authToken: token,
    body,
  });
}
export async function updateLogo(id: any, body: any, token?: string) {
  return fetchAPI(`/seller/tickets/${id}/update-page-details`, {
    method: "POST",
    authToken: token,
    body,
  });
}
export async function holdTicket(body: any, token?: string) {
  return fetchAPI(`/user/hold-tickets`, {
    method: "POST",
    authToken: token,
    body,
  });
}
export async function filterTickets(
  params: Record<string, any>,
  token?: string,
) {
  const queryString = new URLSearchParams(params).toString();
  return fetchAPI(`/user/events/filter-tickets?${queryString}`, {
    method: "GET",
    authToken: token,
    noStore: true,
  });
}
export async function deleteAcc(token?: string) {
  return fetchAPI(`/auth/delete`, {
    method: "POST",
    authToken: token,
  });
}
export async function withdraw(token?: string) {
  return fetchAPI(`/seller/withdraw`, {
    method: "POST",
    authToken: token,
  });
}
export async function marketingWithdraw(token?: string) {
  return fetchAPI(`/marketing/transactions/due`, {
    method: "POST",
    authToken: token,
  });
}

export async function businessWithdraw(token?: string) {
  return fetchAPI(`/business/withdraw`, {
    method: "POST",
    authToken: token,
  });
}
export async function subscribe(email: string) {
  return fetchAPI(`/user/subscribe`, {
    method: "POST",
    body: { email },
  });
}
export async function registerBusiness(data: any) {
  return fetchAPI(`/business/signup`, {
    method: "POST",
    body: data,
  });
}

export async function businessOrders(
  page: string,
  limit: number,
  event?: string,
  event_id?: string,
  token?: string,
) {
  return fetchAPI(
    `/business/orders?limit=${limit}&page=${page}&event=${event}${
      event_id ? `&event_id=${event_id}` : ""
    }`,
    {
      method: "GET",
      authToken: token,
    },
  );
}
export async function businessTickets(
  page: number,
  limit: number,
  event_id?: string,
  token?: string,
  event?: string,
) {
  return fetchAPI(
    `/business/tickets?limit=${limit}&page=${page}&event=${event}${
      event_id ? `&event_id=${event_id}` : ""
    }`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function businessWallet(
  page: string,
  limit: number,
  token?: string,
) {
  return fetchAPI(`/business/wallet?limit=${limit}&page=${page}`, {
    method: "GET",
    authToken: token,
  });
}

export async function businessEvents(
  page = 1,
  limit = 12,
  keyword = "",
  token?: string,
) {
  return fetchAPI(
    `/business/events/search?limit=${limit}&page=${page}&event=${keyword}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function businessEventDetails(id: string, token?: string) {
  return fetchAPI(`/business/events/details/${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function editBusinessEvent(id: string, data: any, token?: string) {
  return fetchAPI(`/business/events/edit/${id}`, {
    method: "PUT",
    authToken: token,
    body: data,
  });
}

export async function businessEventTerms(id: string, token?: string) {
  return fetchAPI(`/business/terms/${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function updateBusinessEventTerms(
  id: string,
  data: any,
  token?: string,
) {
  return fetchAPI(`/business/terms/edit/${id}`, {
    method: "PUT",
    authToken: token,
    body: data,
  });
}

export async function businessSponsors(
  page = 1,
  limit = 10,
  event_id = "",
  token?: string,
) {
  return fetchAPI(
    `/business/sponsors?page=${page}&limit=${limit}&event_id=${event_id}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function addSponsor(data: any, token?: string) {
  return fetchAPI(`/business/sponsors/add`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function deleteSponsorApi(id: string, token?: string) {
  return fetchAPI(`/business/sponsors/delete/${id}`, {
    method: "DELETE",
    authToken: token,
  });
}
export async function editSponsorApi(id: string, data: any, token?: string) {
  return fetchAPI(`/business/sponsors/edit/${id}`, {
    method: "PUT",
    authToken: token,
    body: data,
  });
}

export async function getSponsorApi(id: string, token?: string) {
  return fetchAPI(`/business/sponsors/details/${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function businessEventTickets(
  id: string,
  page = 1,
  limit = 10,
  token?: string,
) {
  return fetchAPI(
    `/business/orders-tickets?event_id=${id}&page=${page}&limit=${limit}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function addEvent(data: any, token?: string) {
  return fetchAPI(`/business/event/store`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function businessDashboard(token?: string) {
  return fetchAPI(`/business/home`, {
    method: "GET",
    authToken: token,
  });
}

export async function fetchMarketingPage(token?: string) {
  return fetchAPI(`/marketing/marketing-page`, {
    method: "GET",
    authToken: token,
  });
}

export async function fetchMarketingHome(token?: string) {
  return fetchAPI(`/marketing/home`, {
    method: "GET",
    authToken: token,
  });
}

export async function fetchMarketingCoupons(
  page: string,
  limit: number,
  token?: string,
) {
  return fetchAPI(`/marketing/promotion-codes?limit=${limit}&page=${page}`, {
    method: "GET",
    authToken: token,
  });
}

export async function createCoupon(data: any, token?: string) {
  return fetchAPI(`/marketing/promotion-codes/store`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function changeCouponStatus(data: any, token?: string) {
  return fetchAPI(`/marketing/change-code-status`, {
    method: "PUT",
    authToken: token,
    body: data,
  });
}

export async function createLink(data: any, token?: string) {
  return fetchAPI(`/marketing/links/store`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}
export async function fetchMarketingLinks(
  page: string,
  limit: number,
  token?: string,
) {
  return fetchAPI(`/marketing/links?limit=${limit}&page=${page}`, {
    method: "GET",
    authToken: token,
  });
}

export async function fetchMarketingEarnings(
  page: string,
  limit: number,
  token?: string,
) {
  return fetchAPI(`/marketing/orders?limit=${limit}&page=${page}`, {
    method: "GET",
    authToken: token,
  });
}

export async function acceptPolicy(data: any, token?: string) {
  return fetchAPI(`/marketing/accept-policy`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function fetchAffiliatePage(id: string, token?: string) {
  return fetchAPI(`/affiliate-event/${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function updateBusinessProfile(data: any, token?: string) {
  return fetchAPI(`/business/edit-profile`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function editEvent(id: string, data: any, token?: string) {
  return fetchAPI(`/business/events/edit/${id}`, {
    method: "PUT",
    authToken: token,
    body: data,
  });
}

export async function addEventTicket(id: string, data: any, token?: string) {
  return fetchAPI(`/business/tickets/${id}/add`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function fetchEventTicketDetails(
  ticketId: string,
  token?: string,
) {
  return fetchAPI(`/business/tickets/details/${ticketId}`, {
    method: "GET",
    authToken: token,
  });
}

export async function updateEventTicket(
  eventId: string,
  ticketId: string,
  data: any,
  token?: string,
) {
  return fetchAPI(`/business/tickets/edit/${ticketId}`, {
    method: "PUT",
    authToken: token,
    body: data,
  });
}

export async function deleteEventTicket(ticketId: string, token?: string) {
  return fetchAPI(`/business/tickets/delete/${ticketId}`, {
    method: "DELETE",
    authToken: token,
  });
}

export async function fetchSoldTickets(
  eventId: string,
  page: number,
  limit: number,
  event: string,
  from_date: string,
  to_date: string,
  token?: string,
) {
  return fetchAPI(
    `/business/orders/tickets?event_id=${eventId}&page=${page}&limit=${limit}&event=${event}&from_date=${from_date}&to_date=${to_date}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function fetchSoldTicketsDetails(
  ticketId: string,
  token?: string,
) {
  return fetchAPI(`/business/orders/tickets/${ticketId}`, {
    method: "GET",
    authToken: token,
  });
}

export async function exportPdf(eventId: string, token?: string) {
  return fetchAPI(`/business/orders/tickets/pdf?event_id=${eventId}`, {
    method: "GET",
    authToken: token,
  });
}
export async function exportDailyReport(eventId: string, token?: string) {
  return fetchAPI(`/business/reports/daily/pdf?event_id=${eventId}`, {
    method: "GET",
    authToken: token,
  });
}
export async function exportPackagesReport(eventId: string, token?: string) {
  return fetchAPI(`/business/reports/tags/pdf?event_id=${eventId}`, {
    method: "GET",
    authToken: token,
  });
}

export async function fetchDailyReport(
  eventId: string,
  page: number,
  limit: number,
  token?: string,
) {
  return fetchAPI(
    `/business/reports/daily?event_id=${eventId}&page=${page}&limit=${limit}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function fetchPackagesReport(
  eventId: string,
  page: number,
  limit: number,
  token?: string,
) {
  return fetchAPI(
    `/business/reports/tags?event_id=${eventId}&page=${page}&limit=${limit}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function fetchPackagesReportDetails(
  tagId: string,

  token?: string,
) {
  return fetchAPI(`/business/reports/tags/${tagId}}`, {
    method: "GET",
    authToken: token,
  });
}

export async function addInvitationDesign(
  data: InvitationDesignFormData,
  token?: string,
) {
  return fetchAPI(`/business/invitations/add`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function getInvitationDesign(id: string, token?: string) {
  return fetchAPI(`/business/invitations?event_id=${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function getInvitationStats(id: string, token?: string) {
  return fetchAPI(`/business/invitations/stats?event_id=${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function sendInvitation(id: string, data: any, token?: string) {
  return fetchAPI(`/business/invitations/send/${id}`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function getInvitations(id: string, token?: string) {
  return fetchAPI(`/business/invitations/users?event_id=${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function createAccount(data: any, token?: string) {
  return fetchAPI(`/business/accounts/create`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function fetchVerifiedAccounts(id: string, token?: string) {
  return fetchAPI(`/business/accounts/verified?event_id=${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function fetchInvitedAccounts(id: string, token?: string) {
  return fetchAPI(`/business/accounts/invited?event_id=${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function deleteAccount(id: string, token?: string) {
  return fetchAPI(`/business/accounts/delete/${id}`, {
    method: "DELETE",
    authToken: token,
  });
}

export async function fetchEmails(id: string, token?: string) {
  return fetchAPI(`/business/emails?event_id=${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function addEmail(data: any, token?: string) {
  return fetchAPI(`/business/emails/add`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function deleteEmail(id: string, token?: string) {
  return fetchAPI(`/business/emails/delete/${id}`, {
    method: "DELETE",
    authToken: token,
  });
}

export async function resendEmail(data: any, token?: string) {
  return fetchAPI(`/business/emails/resend`, {
    method: "POST",
    body: data,
    authToken: token,
  });
}

export async function getEmail(id: string, token?: string) {
  return fetchAPI(`/business/emails/details/${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function updateEmail(id: string, data: any, token?: string) {
  return fetchAPI(`/business/emails/edit/${id}`, {
    method: "PUT",
    body: data,
    authToken: token,
  });
}

export async function createDesign(data: any, token?: string) {
  return fetchAPI(`/business/designs/create`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function fetchDesigns(
  id: string,
  page: number,
  limit: number,
  token?: string,
) {
  return fetchAPI(
    `/business/designs?event_id=${id}&page=${page}&limit=${limit}`,
    {
      method: "GET",
      authToken: token,
    },
  );
}

export async function refundTicket(id: string, token?: string) {
  return fetchAPI(`/business/orders/refund/${id}`, {
    method: "POST",
    authToken: token,
  });
}

export async function recheckTicket(id: string, token?: string) {
  return fetchAPI(`/business/orders/re-check-ticket/${id}`, {
    method: "POST",
    authToken: token,
  });
}

export async function soldTicketsPdf(id: string, token?: string) {
  return fetchAPI(`/business/orders/tickets/pdf?event_id=${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function editDesign(id: string, data: any, token?: string) {
  return fetchAPI(`/business/invitations/update/${id}`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function deleteDesign(id: string, token?: string) {
  return fetchAPI(`/business/invitations/${id}/delete`, {
    method: "DELETE",
    authToken: token,
  });
}

export async function getDesign(id: string, token?: string) {
  return fetchAPI(`/business/invitations/${id}`, {
    method: "GET",
    authToken: token,
  });
}

export async function getRouteMappings(token?: string) {
  return fetchAPI(`/redirect_url`, {
    method: "GET",
    authToken: token,
    next: { revalidate: 300, tags: ["route-mappings"] },
  });
}
export async function getInvoiceDetails(id: string, token?: string) {
  return fetchAPI(`/invoices/details/${id}`, {
    method: "GET",
    authToken: token,
  });
}
// /invoices/cancel/4
export async function getCancelInvoice(id: string, token?: string) {
  return fetchAPI(`/invoices/cancel/${id}`, {
    method: "PUT",
    authToken: token,
  });
}

export async function getInvoiceCommission(amount: string, token?: string) {
  return fetchAPI(`/invoices/payment-methods/commissions?amount=${amount}`, {
    method: "GET",
    authToken: token,
  });
}
export async function createInvoice(formBody: any, token?: string) {
  return fetchAPI(`/invoices/create`, {
    method: "POST",
    authToken: token,
    body: formBody,
  });
}

export async function payInvoice(formBody: any, token?: string) {
  return fetchAPI(`/invoices/pay`, {
    method: "POST",
    authToken: token,
    body: formBody,
  });
}
export async function verefyPayment(formBody: any, token?: string) {
  return fetchAPI(`/invoices/verify-payment`, {
    method: "POST",
    authToken: token,
    body: formBody,
  });
}

export async function verefyWalletPayment(formBody: any, token?: string) {
  return fetchAPI(`/wallet/paid`, {
    method: "POST",
    authToken: token,
    body: formBody,
  });
}

export async function updateInvoicesProfile(formBody: any, token?: string) {
  return fetchAPI(`/invoices/update-profile`, {
    method: "POST",
    authToken: token,
    body: formBody,
  });
}

export async function NewfetchPayementMethod(platform: any) {
  return fetchAPI(`/init?platform=${platform}&version=1.1.0`, {
    method: "GET",
    publicGet: true,
    noStore: true,
  });
}

export async function fetchSubCategories(categoryId: number | string = 72) {
  if (
    categoryId == null ||
    categoryId === "" ||
    String(categoryId) === "undefined"
  ) {
    return { data: [] };
  }
  return fetchAPI(`/user/tag-categories/${categoryId}`, {
    method: "GET",
    publicGet: true,
  });
}

export async function updateEmailCompany(formBody: any, token?: string) {
  return fetchAPI(`/orders/store`, {
    method: "POST",
    authToken: token,
    body: formBody,
  });
}

// 1️⃣ Get BNPL Merchant Config
export const getMerchantConfig = async (merchantId: string) => {
  return fetchAPI(
    `${process.env.NEXT_PUBLIC_EMKAN_BASE_URL || "https://sit-gw-pub.emkanfinance.com.sa"}/retail/bnpl/partner-management/v1/${merchantId}/merchantConfig`,
    {
      method: "GET",
      authToken: `${process.env.EMKAN_USERNAME}:${process.env.EMKAN_PASSWORD}`, // إذا تحب تستخدم Basic Auth
      contentType: "application/json",
    },
  );
};

// 2️⃣ Create BNPL Order
export const createBnplOrder = async (orderData: any) => {
  return fetchAPI(
    `${process.env.NEXT_PUBLIC_EMKAN_BASE_URL || "https://sit-gw-pub.emkanfinance.com.sa"}/retail/bnpl/order-management/v1/order`,
    {
      method: "POST",
      body: orderData,
      authToken: `${process.env.EMKAN_USERNAME}:${process.env.EMKAN_PASSWORD}`,
    },
  );
};

// 3️⃣ Get BNPL Order Status
export const getBnplOrderStatus = async (orderId: string) => {
  return fetchAPI(
    `${process.env.NEXT_PUBLIC_EMKAN_BASE_URL || "https://sit-gw-pub.emkanfinance.com.sa"}/retail/bnpl/order-management/v1/order/${orderId}/status`,
    {
      method: "GET",
      authToken: `${process.env.EMKAN_USERNAME}:${process.env.EMKAN_PASSWORD}`,
    },
  );
};

// 4️⃣ Submit Refund Request
export const submitRefund = async (orderId: string, refundData: any) => {
  return fetchAPI(
    `${process.env.NEXT_PUBLIC_EMKAN_BASE_URL || "https://sit-gw-pub.emkanfinance.com.sa"}/retail/bnpl/order-management/v1/order/${orderId}/refund`,
    {
      method: "POST",
      body: refundData,
      authToken: `${process.env.EMKAN_USERNAME}:${process.env.EMKAN_PASSWORD}`,
    },
  );
};

// 5️⃣ Get Refund Details
export const getRefundDetails = async (orderId: string, refundId: string) => {
  return fetchAPI(
    `${process.env.NEXT_PUBLIC_EMKAN_BASE_URL || "https://sit-gw-pub.emkanfinance.com.sa"}/retail/bnpl/order-management/v1/order/${orderId}/refund/${refundId}`,
    {
      method: "GET",
      authToken: `${process.env.EMKAN_USERNAME}:${process.env.EMKAN_PASSWORD}`,
    },
  );
};

export async function fetchWalletExports(
  page?: string,
  limit = 10,
  token?: string,
) {
  return fetchAPI(`/wallet/transactions/withdraw?limit=${limit}&page=${page}`, {
    method: "GET",
    authToken: token,
    noStore: true,
  });
}

export async function fetchWalletImports(
  page?: string,
  limit = 10,
  token?: string,
) {
  return fetchAPI(`/wallet/transactions/deposit?limit=${limit}&page=${page}`, {
    method: "GET",
    authToken: token,
    noStore: true,
  });
}

export async function withdrawWalletAction(
  data: {
    amount: number;
    bank_account_name: string;
    bank_name: string;
    iban: string;
  },
  token?: string,
) {
  return fetchAPI("/wallet/withdraw", {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function updateWithdrawalAction(
  id: string | number,
  data: {
    amount: number;
    bank_account_name: string;
    bank_name: string;
    iban: string;
  },
  token?: string,
) {
  return fetchAPI(`/wallet/update-withdraw/${id}`, {
    method: "POST",
    authToken: token,
    body: data,
  });
}

export async function cancelWithdrawalAction(
  id: string | number,
  token?: string,
) {
  return fetchAPI(`/wallet/cancel-withdraw/${id}`, {
    method: "POST",
    authToken: token,
  });
}
